import * as React from "react";
import { RBACHidden } from "../helpers/rbac/rbac";
import { GrafferPermissions } from "../../application/domain/rbac/rbac";
import { GroupPermissionAttached } from "../../application/domain/group/grp_resource";
import {
  PrimaryButton,
  SecondaryButton,
} from "@graffer-inc/console-design-kit";

interface RBACButtonProps {
  target?: GroupPermissionAttached;
  requirePermissions: GrafferPermissions;
  buttonText: string;
  buttonTypes: "primary" | "secondary";
}

export const RBACButton: React.FC<
  RBACButtonProps &
    React.DetailedHTMLProps<
      React.ButtonHTMLAttributes<HTMLButtonElement>,
      HTMLButtonElement
    >
> = ({ requirePermissions, target, buttonText, buttonTypes, ...props }) => {
  return (
    <RBACHidden target={target} requirePermissions={requirePermissions}>
      {buttonTypes === "primary" ? (
        <PrimaryButton text={buttonText} {...props} />
      ) : (
        <SecondaryButton text={buttonText} {...props} />
      )}
    </RBACHidden>
  );
};
